import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeImage from './SafeImage';
import '../styles/components/ContentModal.css';

const ContentModal = ({ isOpen, onClose, content, type = 'project' }) => {
  if (!content) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="content-modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleBackdropClick}
        >
          <motion.div
            className="content-modal"
            initial={{ opacity: 0, scale: 0.9, y: 50 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 50 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            {/* Close Button */}
            <button className="content-modal-close" onClick={onClose}>
              <i className="fas fa-times"></i>
            </button>

            {/* Modal Content */}
            <div className="content-modal-body">
              {/* Image */}
              <div className="content-modal-image">
                <SafeImage
                  src={content.image}
                  alt={content.title}
                  width={800}
                  height={500}
                  placeholderText={content.title}
                />
                {/* Status Badge for Experiments */}
                {type === 'experiment' && content.status && (
                  <span
                    className="content-modal-badge"
                    style={{ backgroundColor: content.status_color }}
                  >
                    {content.status}
                  </span>
                )}
              </div>

              {/* Text Content */}
              <div className="content-modal-text">
                <h2 className="content-modal-title">{content.title}</h2>
                <p className="content-modal-description">{content.description}</p>
                {content.metric && (
                  <p className="content-modal-metric">{content.metric}</p>
                )}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContentModal;